import React from 'react';
import { Skeleton } from '@chakra-ui/react';

export function NotificationsListSkeletonLoader({ numItems = 5 }: { numItems?: number }) {
  return (
    <>
      {Array.from(Array(numItems)).map((_, i) => (
        <Skeleton w={'100%'} height={'80px'} my={2} key={i} />
      ))}
    </>
  );
}
